var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './_sds-button-base.lit.scss';
const availableSizes = ['lg', 'md', 'sm'];
/**
 *  Button control that supports configurable size, type, variant and color
 */
let SdsButtonBase = (() => {
    var _a, _SdsButtonBase_loading_accessor_storage, _SdsButtonBase_hint_accessor_storage, _SdsButtonBase_disabled_accessor_storage, _SdsButtonBase_error_accessor_storage, _SdsButtonBase_selected_accessor_storage, _SdsButtonBase_href_accessor_storage, _SdsButtonBase_target_accessor_storage, _SdsButtonBase_label_accessor_storage, _SdsButtonBase_type_accessor_storage, _SdsButtonBase_rounded_accessor_storage, _SdsButtonBase_primary_accessor_storage, _SdsButtonBase_withShadow_accessor_storage, _SdsButtonBase_transparent_accessor_storage, _SdsButtonBase_buttonType_accessor_storage, _SdsButtonBase_badge_accessor_storage, _SdsButtonBase_iconName_accessor_storage, _SdsButtonBase_icon_accessor_storage, _SdsButtonBase_breadcrumbs_accessor_storage;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _error_decorators;
    let _error_initializers = [];
    let _error_extraInitializers = [];
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _href_decorators;
    let _href_initializers = [];
    let _href_extraInitializers = [];
    let _target_decorators;
    let _target_initializers = [];
    let _target_extraInitializers = [];
    let _label_decorators;
    let _label_initializers = [];
    let _label_extraInitializers = [];
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _rounded_decorators;
    let _rounded_initializers = [];
    let _rounded_extraInitializers = [];
    let _primary_decorators;
    let _primary_initializers = [];
    let _primary_extraInitializers = [];
    let _withShadow_decorators;
    let _withShadow_initializers = [];
    let _withShadow_extraInitializers = [];
    let _transparent_decorators;
    let _transparent_initializers = [];
    let _transparent_extraInitializers = [];
    let _buttonType_decorators;
    let _buttonType_initializers = [];
    let _buttonType_extraInitializers = [];
    let _badge_decorators;
    let _badge_initializers = [];
    let _badge_extraInitializers = [];
    let _iconName_decorators;
    let _iconName_initializers = [];
    let _iconName_extraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _set_size_decorators;
    let _breadcrumbs_decorators;
    let _breadcrumbs_initializers = [];
    let _breadcrumbs_extraInitializers = [];
    return _a = class SdsButtonBase extends _classSuper {
            /**
             * True if button is loading
             * @attr
             */
            get loading() { return __classPrivateFieldGet(this, _SdsButtonBase_loading_accessor_storage, "f"); }
            set loading(value) { __classPrivateFieldSet(this, _SdsButtonBase_loading_accessor_storage, value, "f"); }
            /**
             * True if button with hint
             * @attr
             */
            get hint() { return __classPrivateFieldGet(this, _SdsButtonBase_hint_accessor_storage, "f"); }
            set hint(value) { __classPrivateFieldSet(this, _SdsButtonBase_hint_accessor_storage, value, "f"); }
            /**
             * True if button is disabled
             * @attr
             */
            get disabled() { return __classPrivateFieldGet(this, _SdsButtonBase_disabled_accessor_storage, "f"); }
            set disabled(value) { __classPrivateFieldSet(this, _SdsButtonBase_disabled_accessor_storage, value, "f"); }
            /**
             * True if button is error
             * @attr
             */
            get error() { return __classPrivateFieldGet(this, _SdsButtonBase_error_accessor_storage, "f"); }
            set error(value) { __classPrivateFieldSet(this, _SdsButtonBase_error_accessor_storage, value, "f"); }
            /**
             * True if button is selected
             * @attr
             */
            get selected() { return __classPrivateFieldGet(this, _SdsButtonBase_selected_accessor_storage, "f"); }
            set selected(value) { __classPrivateFieldSet(this, _SdsButtonBase_selected_accessor_storage, value, "f"); }
            /**
             * Link href of button
             * @attr
             */
            get href() { return __classPrivateFieldGet(this, _SdsButtonBase_href_accessor_storage, "f"); }
            set href(value) { __classPrivateFieldSet(this, _SdsButtonBase_href_accessor_storage, value, "f"); }
            /**
             * Target of button link
             * @attr
             */
            get target() { return __classPrivateFieldGet(this, _SdsButtonBase_target_accessor_storage, "f"); }
            set target(value) { __classPrivateFieldSet(this, _SdsButtonBase_target_accessor_storage, value, "f"); }
            /**
             * label for button
             * @attr
             */
            get label() { return __classPrivateFieldGet(this, _SdsButtonBase_label_accessor_storage, "f"); }
            set label(value) { __classPrivateFieldSet(this, _SdsButtonBase_label_accessor_storage, value, "f"); }
            /**
             * Button type
             * @attr
             */
            get type() { return __classPrivateFieldGet(this, _SdsButtonBase_type_accessor_storage, "f"); }
            set type(value) { __classPrivateFieldSet(this, _SdsButtonBase_type_accessor_storage, value, "f"); }
            /**
             * True if button is with rounded corners
             * @attr
             */
            get rounded() { return __classPrivateFieldGet(this, _SdsButtonBase_rounded_accessor_storage, "f"); }
            set rounded(value) { __classPrivateFieldSet(this, _SdsButtonBase_rounded_accessor_storage, value, "f"); }
            /**
             * True if ghost icon button have primary color
             * @attr
             */
            get primary() { return __classPrivateFieldGet(this, _SdsButtonBase_primary_accessor_storage, "f"); }
            set primary(value) { __classPrivateFieldSet(this, _SdsButtonBase_primary_accessor_storage, value, "f"); }
            /**
             * True if button is with shadow
             * @attr
             */
            get withShadow() { return __classPrivateFieldGet(this, _SdsButtonBase_withShadow_accessor_storage, "f"); }
            set withShadow(value) { __classPrivateFieldSet(this, _SdsButtonBase_withShadow_accessor_storage, value, "f"); }
            /**
             * True if button is transparent
             * @attr
             */
            get transparent() { return __classPrivateFieldGet(this, _SdsButtonBase_transparent_accessor_storage, "f"); }
            set transparent(value) { __classPrivateFieldSet(this, _SdsButtonBase_transparent_accessor_storage, value, "f"); }
            /**
             * Specifies the type of the button. Can be 'submit', 'reset', or 'button'.
             * @attr button-type
             */
            get buttonType() { return __classPrivateFieldGet(this, _SdsButtonBase_buttonType_accessor_storage, "f"); }
            set buttonType(value) { __classPrivateFieldSet(this, _SdsButtonBase_buttonType_accessor_storage, value, "f"); }
            /**
             * The badge displayed on the dropdown button.
             * This attribute is used only for main navigation dropdowns.
             *
             * @attr {string} badge - A badge to show on the button.
             */
            get badge() { return __classPrivateFieldGet(this, _SdsButtonBase_badge_accessor_storage, "f"); }
            set badge(value) { __classPrivateFieldSet(this, _SdsButtonBase_badge_accessor_storage, value, "f"); }
            /**
             * Transforms the icon name string by:
             * 1. Replacing all underscores (`_`) with spaces.
             * 2. Capitalizing the first letter of each word.
             *
             * ### Accessibility
             * - Converts technical icon names into readable strings for assistive technologies.
             * - For example:
             *   - Input: `arrow_down_small`
             *   - Output: `Arrow Down Small`
             *
             * @param value - The raw icon name string.
             * @returns The processed and human-readable icon name, suitable for accessibility purposes.
             */
            get iconName() { return __classPrivateFieldGet(this, _SdsButtonBase_iconName_accessor_storage, "f"); }
            set iconName(value) { __classPrivateFieldSet(this, _SdsButtonBase_iconName_accessor_storage, value, "f"); }
            /**
             * Button icon
             * @attr
             */
            get icon() { return __classPrivateFieldGet(this, _SdsButtonBase_icon_accessor_storage, "f"); }
            set icon(value) { __classPrivateFieldSet(this, _SdsButtonBase_icon_accessor_storage, value, "f"); }
            get size() {
                return this._size;
            }
            set size(value) {
                const oldValue = this._size;
                this._size = value;
                this.requestUpdate('size', oldValue);
            }
            get breadcrumbs() { return __classPrivateFieldGet(this, _SdsButtonBase_breadcrumbs_accessor_storage, "f"); }
            set breadcrumbs(value) { __classPrivateFieldSet(this, _SdsButtonBase_breadcrumbs_accessor_storage, value, "f"); }
            constructor() {
                super();
                _SdsButtonBase_loading_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _loading_initializers, false)));
                _SdsButtonBase_hint_accessor_storage.set(this, (__runInitializers(this, _loading_extraInitializers), __runInitializers(this, _hint_initializers, false)));
                _SdsButtonBase_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
                _SdsButtonBase_error_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _error_initializers, false)));
                _SdsButtonBase_selected_accessor_storage.set(this, (__runInitializers(this, _error_extraInitializers), __runInitializers(this, _selected_initializers, false)));
                _SdsButtonBase_href_accessor_storage.set(this, (__runInitializers(this, _selected_extraInitializers), __runInitializers(this, _href_initializers, void 0)));
                _SdsButtonBase_target_accessor_storage.set(this, (__runInitializers(this, _href_extraInitializers), __runInitializers(this, _target_initializers, void 0)));
                _SdsButtonBase_label_accessor_storage.set(this, (__runInitializers(this, _target_extraInitializers), __runInitializers(this, _label_initializers, '')));
                _SdsButtonBase_type_accessor_storage.set(this, (__runInitializers(this, _label_extraInitializers), __runInitializers(this, _type_initializers, 'primary')));
                _SdsButtonBase_rounded_accessor_storage.set(this, (__runInitializers(this, _type_extraInitializers), __runInitializers(this, _rounded_initializers, false)));
                _SdsButtonBase_primary_accessor_storage.set(this, (__runInitializers(this, _rounded_extraInitializers), __runInitializers(this, _primary_initializers, false)));
                _SdsButtonBase_withShadow_accessor_storage.set(this, (__runInitializers(this, _primary_extraInitializers), __runInitializers(this, _withShadow_initializers, false)));
                _SdsButtonBase_transparent_accessor_storage.set(this, (__runInitializers(this, _withShadow_extraInitializers), __runInitializers(this, _transparent_initializers, false)));
                _SdsButtonBase_buttonType_accessor_storage.set(this, (__runInitializers(this, _transparent_extraInitializers), __runInitializers(this, _buttonType_initializers, 'button')));
                _SdsButtonBase_badge_accessor_storage.set(this, (__runInitializers(this, _buttonType_extraInitializers), __runInitializers(this, _badge_initializers, void 0)));
                _SdsButtonBase_iconName_accessor_storage.set(this, (__runInitializers(this, _badge_extraInitializers), __runInitializers(this, _iconName_initializers, '')));
                _SdsButtonBase_icon_accessor_storage.set(this, (__runInitializers(this, _iconName_extraInitializers), __runInitializers(this, _icon_initializers, '')));
                this._iconSize = (__runInitializers(this, _icon_extraInitializers), 24);
                /**
                 * Button size
                 * @attr
                 */
                this._size = 'lg';
                _SdsButtonBase_breadcrumbs_accessor_storage.set(this, __runInitializers(this, _breadcrumbs_initializers, false));
                __runInitializers(this, _breadcrumbs_extraInitializers);
                this.disableClickWhenButtonIsDisabled();
            }
            updated(changedProperties) {
                if (changedProperties.has('icon')) {
                    this.iconName = this.replaceUnderscoreWithSpace(this.icon);
                }
                if (changedProperties.has('error') ||
                    changedProperties.has('disabled') ||
                    changedProperties.has('loading')) {
                    this.handleDisabledErrorToggle();
                }
                if (!['submit', 'reset', 'button'].includes(this.buttonType)) {
                    this.buttonType = 'button';
                }
            }
            handleDisabledErrorToggle() {
                if (this.error && this.disabled) {
                    this.error = false;
                }
                if (this.hasAttribute('error') && !this.disabled) {
                    this.error = true;
                }
                if (this.loading && this.disabled) {
                    this.loading = false;
                }
                if (this.hasAttribute('loading') && !this.disabled) {
                    this.loading = true;
                }
                // if (this.error && this.loading) {
                //     this.loading = false;
                // }
                //
                // if (this.hasAttribute('loading') && !this.error) {
                //     this.loading = true;
                // }
            }
            replaceUnderscoreWithSpace(value) {
                if (typeof value !== 'string') {
                    return '';
                }
                return value.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
            }
            disableClickWhenButtonIsDisabled() {
                this.addEventListener('click', event => {
                    if (this.disabled || this.loading) {
                        event.stopImmediatePropagation();
                        event.preventDefault();
                        event.returnValue = false;
                    }
                }, true);
            }
            willUpdate(changedProperties) {
                if (changedProperties.has('size')) {
                    this._size === 'lg' ? (this._iconSize = 24) : (this._iconSize = 16);
                }
            }
            getClasses() {
                return classMap({
                    'sds-button': true,
                    'sds-button--filled': this.type === 'filled' || this.type === 'primary',
                    'sds-button--elevated': this.type === 'elevated' || this.withShadow,
                    'sds-button--transparent': this.type === 'transparent' || this.transparent,
                    'sds-button--outlined': this.type === 'outlined' || this.type === 'secondary',
                    'sds-button--ghost': this.type === 'ghost' || this.type === 'tertiary',
                    'sds-button--secondary': this.type === 'secondary', // deprecated
                    'sds-button--tertiary': this.type === 'tertiary', // deprecated
                    'sds-button--link': this.type === 'link',
                    'sds-button--text-with-icon': this.label && this.icon,
                    'sds-button--icon': !this.label && this.icon,
                    'sds-button--lg': this.size === 'lg',
                    'sds-button--md': this.size === 'md',
                    'sds-button--sm': this.size === 'sm',
                    'sds-button--breadcrumbs': this.breadcrumbs,
                    'sds-button--loading': this.loading,
                    'sds-button--disabled': this.disabled,
                    'sds-button--rounded': this.rounded,
                    'sds-button--selected': this.selected,
                    'sds-button--error': this.error,
                    'sds-button--hint': this.hint,
                    'sds-button--primary-color': this.primary,
                });
            }
        },
        _SdsButtonBase_loading_accessor_storage = new WeakMap(),
        _SdsButtonBase_hint_accessor_storage = new WeakMap(),
        _SdsButtonBase_disabled_accessor_storage = new WeakMap(),
        _SdsButtonBase_error_accessor_storage = new WeakMap(),
        _SdsButtonBase_selected_accessor_storage = new WeakMap(),
        _SdsButtonBase_href_accessor_storage = new WeakMap(),
        _SdsButtonBase_target_accessor_storage = new WeakMap(),
        _SdsButtonBase_label_accessor_storage = new WeakMap(),
        _SdsButtonBase_type_accessor_storage = new WeakMap(),
        _SdsButtonBase_rounded_accessor_storage = new WeakMap(),
        _SdsButtonBase_primary_accessor_storage = new WeakMap(),
        _SdsButtonBase_withShadow_accessor_storage = new WeakMap(),
        _SdsButtonBase_transparent_accessor_storage = new WeakMap(),
        _SdsButtonBase_buttonType_accessor_storage = new WeakMap(),
        _SdsButtonBase_badge_accessor_storage = new WeakMap(),
        _SdsButtonBase_iconName_accessor_storage = new WeakMap(),
        _SdsButtonBase_icon_accessor_storage = new WeakMap(),
        _SdsButtonBase_breadcrumbs_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _loading_decorators = [property({ type: Boolean })];
            _hint_decorators = [property({ type: Boolean })];
            _disabled_decorators = [property({ type: Boolean })];
            _error_decorators = [property({ type: Boolean })];
            _selected_decorators = [property({ type: Boolean, reflect: true })];
            _href_decorators = [property({ type: String })];
            _target_decorators = [property({ type: String })];
            _label_decorators = [property({ type: String })];
            _type_decorators = [property({ type: String })];
            _rounded_decorators = [property({ type: Boolean })];
            _primary_decorators = [property({ type: Boolean })];
            _withShadow_decorators = [property({ type: Boolean, attribute: 'with-shadow' })];
            _transparent_decorators = [property({ type: Boolean })];
            _buttonType_decorators = [property({ type: String, attribute: 'button-type' })];
            _badge_decorators = [property({ type: String })];
            _iconName_decorators = [state()];
            _icon_decorators = [property({ type: String })];
            _set_size_decorators = [property({
                    type: String,
                    hasChanged: (newVal) => {
                        if (!availableSizes.includes(newVal)) {
                            console.error(`Unexpected Size ${newVal}`);
                            return false;
                        }
                        else {
                            return true;
                        }
                    },
                })];
            _breadcrumbs_decorators = [property({ type: Boolean })];
            __esDecorate(_a, null, _loading_decorators, { kind: "accessor", name: "loading", static: false, private: false, access: { has: obj => "loading" in obj, get: obj => obj.loading, set: (obj, value) => { obj.loading = value; } }, metadata: _metadata }, _loading_initializers, _loading_extraInitializers);
            __esDecorate(_a, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
            __esDecorate(_a, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
            __esDecorate(_a, null, _error_decorators, { kind: "accessor", name: "error", static: false, private: false, access: { has: obj => "error" in obj, get: obj => obj.error, set: (obj, value) => { obj.error = value; } }, metadata: _metadata }, _error_initializers, _error_extraInitializers);
            __esDecorate(_a, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
            __esDecorate(_a, null, _href_decorators, { kind: "accessor", name: "href", static: false, private: false, access: { has: obj => "href" in obj, get: obj => obj.href, set: (obj, value) => { obj.href = value; } }, metadata: _metadata }, _href_initializers, _href_extraInitializers);
            __esDecorate(_a, null, _target_decorators, { kind: "accessor", name: "target", static: false, private: false, access: { has: obj => "target" in obj, get: obj => obj.target, set: (obj, value) => { obj.target = value; } }, metadata: _metadata }, _target_initializers, _target_extraInitializers);
            __esDecorate(_a, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: obj => "label" in obj, get: obj => obj.label, set: (obj, value) => { obj.label = value; } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
            __esDecorate(_a, null, _type_decorators, { kind: "accessor", name: "type", static: false, private: false, access: { has: obj => "type" in obj, get: obj => obj.type, set: (obj, value) => { obj.type = value; } }, metadata: _metadata }, _type_initializers, _type_extraInitializers);
            __esDecorate(_a, null, _rounded_decorators, { kind: "accessor", name: "rounded", static: false, private: false, access: { has: obj => "rounded" in obj, get: obj => obj.rounded, set: (obj, value) => { obj.rounded = value; } }, metadata: _metadata }, _rounded_initializers, _rounded_extraInitializers);
            __esDecorate(_a, null, _primary_decorators, { kind: "accessor", name: "primary", static: false, private: false, access: { has: obj => "primary" in obj, get: obj => obj.primary, set: (obj, value) => { obj.primary = value; } }, metadata: _metadata }, _primary_initializers, _primary_extraInitializers);
            __esDecorate(_a, null, _withShadow_decorators, { kind: "accessor", name: "withShadow", static: false, private: false, access: { has: obj => "withShadow" in obj, get: obj => obj.withShadow, set: (obj, value) => { obj.withShadow = value; } }, metadata: _metadata }, _withShadow_initializers, _withShadow_extraInitializers);
            __esDecorate(_a, null, _transparent_decorators, { kind: "accessor", name: "transparent", static: false, private: false, access: { has: obj => "transparent" in obj, get: obj => obj.transparent, set: (obj, value) => { obj.transparent = value; } }, metadata: _metadata }, _transparent_initializers, _transparent_extraInitializers);
            __esDecorate(_a, null, _buttonType_decorators, { kind: "accessor", name: "buttonType", static: false, private: false, access: { has: obj => "buttonType" in obj, get: obj => obj.buttonType, set: (obj, value) => { obj.buttonType = value; } }, metadata: _metadata }, _buttonType_initializers, _buttonType_extraInitializers);
            __esDecorate(_a, null, _badge_decorators, { kind: "accessor", name: "badge", static: false, private: false, access: { has: obj => "badge" in obj, get: obj => obj.badge, set: (obj, value) => { obj.badge = value; } }, metadata: _metadata }, _badge_initializers, _badge_extraInitializers);
            __esDecorate(_a, null, _iconName_decorators, { kind: "accessor", name: "iconName", static: false, private: false, access: { has: obj => "iconName" in obj, get: obj => obj.iconName, set: (obj, value) => { obj.iconName = value; } }, metadata: _metadata }, _iconName_initializers, _iconName_extraInitializers);
            __esDecorate(_a, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
            __esDecorate(_a, null, _set_size_decorators, { kind: "setter", name: "size", static: false, private: false, access: { has: obj => "size" in obj, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _breadcrumbs_decorators, { kind: "accessor", name: "breadcrumbs", static: false, private: false, access: { has: obj => "breadcrumbs" in obj, get: obj => obj.breadcrumbs, set: (obj, value) => { obj.breadcrumbs = value; } }, metadata: _metadata }, _breadcrumbs_initializers, _breadcrumbs_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        _a.styles = styles,
        _a;
})();
export { SdsButtonBase };
